module.exports = __webpack_public_path__ + "img/bill_hero_mobile.9a843ce7.png";